import { useEffect, useMemo, useState } from "react";
import ReactTable from "../../common/react-table/ReactTable";

import deactiveIMG from "../../assets/images/plusicn.svg";
import editIMG from "../../assets/images/edit.svg";
import ActionIMG from "../../assets/images/action.svg";
import infoIMG from "../../assets/images/infoicn.svg"
import trashImg from "../../assets/images/trash.svg";
import active_icon from "../../assets/images/active_icon.svg";
import moment from "moment";
import { OverlayTrigger, Popover, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getRoleListing } from "../../features/role-management/roleListingSlice";
import { RoleRightsForModule } from "../../utils/utils";
import ConfirmationModal from "../../common/modal/ConfirmationModal";
import { deleteRole } from "../../features/role-management/deleteRoleSlice";
import { OK } from "../../constants/statusCode";
import { activeRole } from "../../features/role-management/activeRoleSlice";

const RoleManagementListing = ({ setSubCategory, subCategory, setRoleEditID, searchValue, setRoleName }) => {

    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [currentModal, setCurrentModal] = useState(false);
    const [roleuuid, setRoleuuid] = useState('');
    const [userEmail, setUserEmail] = useState([]);
    let projectData = JSON.parse(localStorage.getItem("_user"));
    let dispatch = useDispatch();

    /* let projectData = JSON.parse(localStorage.getItem("_user")); */
    /* console.log("userEmail=",userEmail) */
    /**
     * useSelector data
     */
    const { roleListing = null, total_count = null, } = useSelector((state) => ({
        roleListing: state.getRoleListing?.roleListing?.role,
        total_count: state.getRoleListing?.roleListing?.pagination?.total_records
    }))

    /**
     * usEffect for get role listing
     */
    useEffect(() => {
        dispatch(getRoleListing({ perPage: perPage, page: currentPage, /* project_uuid: projectData?.projects[0]?.uuid, */ search: searchValue, organisation_uuid: projectData?.organizations[0].uuid }));
    }, [perPage, currentPage, searchValue]);

    /**
     * handle page function
     * @param {*} page 
     */
    const handleTotalPage = (page) => {
        setPerPage(Number(page));
        setCurrentPage(1);
    };

    /**
     * handle current page function
     * @param {*} page 
     */
    const handleCurrentPage = (page) => {
        setCurrentPage(Number(page));
    };

    /**
     * modal toggle function
     */
    const toggleModal = () => {
        setCurrentModal("");
    };

    /**
     * delete role fnction
     */
    const handleDelete = async () => {
        const { payload } = await dispatch(deleteRole(roleuuid));
        if (payload.status === OK) {
            dispatch(getRoleListing({ perPage: perPage, page: currentPage, search: searchValue, organisation_uuid: projectData?.organizations[0].uuid }));
            setRoleuuid("")
        }
        toggleModal();
    }

    /**
     * active and deactive role function
     */
    const handleActivateDeactivate = async () => {
        let { payload } = await dispatch(activeRole(roleuuid));
        if (payload.status === OK) {
            dispatch(getRoleListing({ perPage: perPage, page: currentPage, organisation_uuid: projectData?.organizations[0].uuid }));
            toggleModal();
        }
    }

    /**
     * popover function
     */
    const renderTooltip = (props) => {
        return (<Popover id="popover-basic">
            <Popover.Header as="h3">Author</Popover.Header>
            <Popover.Body>
                rehan@ymail.com
            </Popover.Body>
        </Popover>)
    }
    const popover = (
        <Popover id="popover-basic">
            <Popover.Header as="h3">Author</Popover.Header>
            <Popover.Body>
                rehan@ymail.com
            </Popover.Body>
        </Popover>
    );
    /* const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Simple tooltip
        </Tooltip>
    ); */

    /**
     * role managment listing columns
     */
    let columns = [
        {
            Header: "Role Name",
            accessor: "name",
        },
        /*  {
             Header: "Description",
             accessor: "description",
         }, */
        {
            Header: "# of Users",
            accessor: "of_users",
            Cell: (props) => {
                /* setUserEmail(props?.row?.original?.Users) */
                return (
                    <>
                        <span>{props?.row?.original?.user_count}</span>
                        <OverlayTrigger trigger={['click']} placement="bottom" overlay={<Popover id="popover-basic">
                            <Popover.Header className="text-center" as="h3">Author</Popover.Header>
                            <Popover.Body className="pop-scroll">
                                {props?.row?.original?.Users?.map((data, index) => {
                                    return (<div key={index}>{data.email}</div>)
                                })}
                            </Popover.Body>
                        </Popover>}>
                            <img className="info-btnicn" src={infoIMG} alt="infoicn.svg" />
                        </OverlayTrigger>
                        {/*  <OverlayTrigger
                                    placement="right"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={renderTooltip}
                                >
                                    <img className="info-btnicn" src={infoIMG} alt="infoicn.svg" />
                                </OverlayTrigger> */}
                    </>
                )
            }
        },
        {
            Header: "Created Date",
            accessor: "created_at",
            Cell: (props) => {
                return (
                    <>
                        {moment(props?.row?.original?.created_at).utc().local().format("MMM DD YYYY, h:mm a")}
                    </>
                )
            }
        },
        {
            Header: "Status",
            accessor: "status",
            Cell: (props) => {
                return (
                    <div className={`${props?.row?.original?.is_active === 1 ? 'active-btn light-green' : 'active-btn light-gray'}`}>
                        {props?.row?.original?.is_active === 1 ? 'Active' : 'Deactivate'}
                    </div>
                )
            }
        },
        {
            Header: "Action",
            Cell: (props) => {

                return (
                    <div className="dropdown action-dropdown user-table-dropdown">
                        <button
                            className="btn dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            <img src={ActionIMG} alt="" />
                        </button>
                        <ul className="dropdown-menu">
                            <li
                                className="dropdown-item mt-1" onClick={() => {
                                    setCurrentModal("activateDeactivateUser");
                                    setRoleuuid(props?.row?.original?.uuid)
                                }}
                            >
                                <span>
                                    <img
                                        className={`trnsfomr user-table-drow-img ${props?.row?.original?.is_active === 1 ? "" : "activate-img"
                                            }`}
                                        src={props?.row?.original?.is_active === 0 ? active_icon : deactiveIMG}
                                        alt=""
                                    />
                                </span>
                                {props?.row?.original?.is_active === 0 ? "Active" : "Deactivate"}
                            </li>
                            {RoleRightsForModule("Update", "Roles") &&
                                <li
                                    className="dropdown-item mt-1"
                                    onClick={() => { setSubCategory("add_role"); setRoleEditID(props?.row?.original?.uuid); setRoleName(props?.row?.original?.name) }}
                                >
                                    <span>
                                        <img src={editIMG} alt="" />
                                    </span>
                                    Edit
                                </li>}
                            {RoleRightsForModule("Delete", "Roles") &&
                                <li
                                    className="dropdown-item mt-1"
                                    onClick={() => {
                                        setCurrentModal("deleteModal");
                                        setRoleuuid(props?.row?.original?.uuid)
                                    }}
                                >
                                    <span>
                                        <img src={trashImg} alt="" />
                                    </span>
                                    Delete
                                </li>}
                        </ul>
                    </div>
                )
            }
        }
    ];

    return (
        <>
            <ReactTable
                className={"role-manage-table"}
                columns={columns}
                data={roleListing?.length > 0 ? roleListing : []}
                currentPage={currentPage}
                perPage={perPage}
                totalCount={total_count}
                handlePerPage={handleTotalPage}
                isCheckBox={false}
                onPageChange={(page) => {
                    handleCurrentPage(page);
                }}
                isDocumentListing={false}
            />

            {/* modal */}
            {currentModal === "deleteModal" && (
                <ConfirmationModal
                    title={"Delete Confirmation"}
                    isOpen={currentModal === "deleteModal"}
                    toggle={toggleModal}
                    onConfirm={handleDelete}
                    message="Are you sure you want to delete this role?"
                />
            )}
            {currentModal === "activateDeactivateUser" && (
                <ConfirmationModal
                    title={"Activate/Deactivate Confirmation"}
                    isOpen={currentModal === "activateDeactivateUser"}
                    toggle={toggleModal}
                    onConfirm={handleActivateDeactivate}
                    message="Are you sure you want to Activate/Deactivate this role?"
                />
            )}
        </>
    )
};

export default RoleManagementListing;